<re-alert *ngIf="alert" [type]="alert.type" (close)="alert = null">
  {{alert.message}}
</re-alert>

<h1  >Configurations</h1>

<div class="table-responsive afterHeader">
  <table class="table table-striped table-bordered user-list">
    <thead class="thead">
      <tr>
        <th>ID</th>
        <th>Configuration Name</th>
        <th>Created By</th>
        <th>Created Date</th>
        <th>Customer Name</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let config of configurations">
        <td>
          {{config.id}}
        </td>
        <td>
          <a [routerLink]="['/ect/configurations/detail/', config.id ]">{{ config.configName }}</a>
        </td>
        <td>
          {{config.createdBy}}
        </td>
        <td>
          {{config.createdDate | date:'medium'}}
        </td>
        <td>
          <a [routerLink]="['/ect/customers/detail/', config.customerId ]">{{ config.customerId }}</a>
        </td>
      </tr>
      <tr *ngIf="!loading && (!configurations || configurations.length === 0)">
        <td class="text-center h6" colspan="6">No Matching Records Found.</td>
      </tr>
    </tbody>
  </table>
</div>
<div class="spinner spinner-sm" *ngIf="loading">
  <div class="lspinner"></div>
</div>
